import React from "react";

import NewsCard from "./newsCard";
import getAllNews from "../../utils/getAllNews";

interface LatestNewsCardsProps {
  pressCategories?: Queries.Maybe<Queries.kontent_item_taxonomy_element[]>;
  newsCategories?: Queries.Maybe<Queries.kontent_item_taxonomy_element[]>;
}

const LatestNewsCards: React.FC<LatestNewsCardsProps> = ({ pressCategories = [], newsCategories = [] }) => {
  const data = getAllNews();

  let pressArticles = [];
  let newsArticles = [];

  if ((pressCategories?.length ?? 0) > 0) {
    pressArticles = data.allKontentItemArticlePress.nodes.filter((article: Queries.kontent_item_article_press) => (
      article.elements?.news_category?.value?.find((item) => (
        pressCategories?.find((cat) => (cat.codename === item?.codename))
      ))
    ));
  }

  if ((newsCategories?.length ?? 0) > 0 && !newsCategories?.find((item) => (item.codename === "all_news"))) {
    newsArticles = data.allKontentItemArticlePageNews.nodes.filter((newsArticle: Queries.kontent_item_article_page_news) => (
      newsArticle.elements?.news_category?.value?.find((item) => (
        newsCategories?.find((cat) => (cat.codename === item.codename))
      ))
    ));
  } else {
    newsArticles = data.allKontentItemArticlePageNews.nodes;
  }

  const articles = newsArticles.slice(0, 10).concat(
    data.allKontentItemArticleMigration.nodes.slice(0, 10).concat(pressArticles.slice(0, 10)),
  );

  if (data.allKontentItemArticlePageNews) {
    return NewsCard({ currentFirst: true, data: articles, limit: 10 });
  }

  return null;
};

export default LatestNewsCards;
